import Tag from '../reusable/Tag';
import { USER_ROLES } from '../../constants';

interface SchoolReportStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
  userRole?: string;
}

export const getSchoolReportStatusDisplay = (
  status: string | null,
  userRole?: string
): { text: string; type: 'pending' | 'completed' | 'progress' | 'error' } => {
  switch (status) {
    case 'SCHOOL_REPORT_GENERATION_LOCKED':
      return { text: 'Not started', type: 'pending' };
    case 'SCHOOL_REPORT_NOT_GENERATED':
      return { text: 'Not started', type: 'pending' };
    case 'SCHOOL_REPORT_GENERATION_IN_PROGRESS':
      return { text: 'Report generation in progress', type: 'progress' };
    case 'SCHOOL_REPORT_GENERATION_FAILED':
      return { text: 'Report generation in progress', type: 'progress' };
    case 'SCHOOL_REPORT_GENERATED':
      return { text: 'Report created', type: 'progress' };
    case 'SCHOOL_REPORT_READY_FOR_INTERNAL_REVIEW':
      return { text: 'Ready for internal review', type: 'progress' };
    case 'SCHOOL_REPORT_APPROVED_BY_LEAD_FACILITATOR':
      return {
        text: 'Approved by Lead Facilitator',
        type: userRole === USER_ROLES.LEAD_FACILITATOR ? 'completed' : 'progress',
      };
    case 'SCHOOL_REPORT_READY_FOR_DISTRICT_REVIEW':
      return { text: 'Ready for district review', type: 'progress' };
    case 'SCHOOL_REPORT_REJECTED':
      return { text: 'Report created', type: 'progress' };
    case 'SCHOOL_REPORT_FINALIZED':
      return { text: 'Approved by district', type: 'completed' };
    default:
      return { text: 'Not started', type: 'pending' };
  }
};

const SchoolReportStatus = ({ status, size = 'small', className, userRole }: SchoolReportStatusProps) => {
  const { text, type } = getSchoolReportStatusDisplay(status, userRole);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default SchoolReportStatus;
